import AssessmentIcon from '@material-ui/icons/Assessment'
import AssetCustomFieldCreate from './AssetCustomFieldCreate'
import AssetCustomFieldEdit from './AssetCustomFieldEdit'
import AssetCustomFieldList from './AssetCustomFieldList'

const assetCustomFields = (permissions: string[]) => ({
  create: permissions.includes('create:assets') ? AssetCustomFieldCreate : undefined,
  edit: permissions.includes('update:assets') ? AssetCustomFieldEdit : undefined,
  icon: AssessmentIcon,
  list: permissions.includes('read:assets') ? AssetCustomFieldList : undefined,
  name: 'asset-custom-fields',
})

export default assetCustomFields
